import { Button } from '@cokitchen/cokitchen-components';
import React, { useState } from 'react';
import { getOrderStatus, truncateString } from 'utils/functions';
import { OrderType } from 'models/order.model';
import { ReactComponent as Line2 } from 'assets/icons/Line2.svg';
import useDashboardContext from 'contexts/dashboard.context';
import { LocationIcon } from 'cokitchen-icons';
import { ReactComponent as CommentIcon } from 'assets/icons/note.svg';

import moment from 'moment';
import GroupOrderMealAccordion from 'components/meal-accordion/group-order-meal-accordion';
import BulkOrderMealAccordion from 'components/meal-accordion/bulk-order-meal-accordion';
import ComplaintModal from 'components/modals/complaint-log-modal';

type Props = {
  order: OrderType;
};
const CancelledOrder = ({ order }: Props) => {
  const { cokitchenList } = useDashboardContext();
  const [showComplaintModal, setShowComplaintModal] = useState(false);
  const orderCokitchen = cokitchenList.find(
    (cokitchen) => cokitchen.id === order?.calculated_order.cokitchen_id
  );

  return (
    <div className='flex flex-col gap-10'>
      <div className='flex items-center justify-between flex-wrap gap-3'>
        <div className='flex items-center gap-2'>
          <p className='text-gray-10 text-xl md:text-2xl font-semibold'>
            Order #{order?.order_code}
          </p>
          <div className='h-[22px] flex items-center justify-center gap-1 px-2 rounded-[40px] bg-[#FFF2E0]'>
            <div className='w-2 h-2 rounded-full bg-[#E60A2B]' />
            <p className='text-xs font-medium capitalize text-[#E60A2B]'>{getOrderStatus(order)}</p>
          </div>
        </div>
        <Button
          variant='block'
          color='primary'
          className='w-fit h-[40px]'
          onClick={() => setShowComplaintModal(true)}>
          Got a complaint?
        </Button>
      </div>

      <div className='bg-[#F7F7F8] w-full h-full lg:h-[80vh] rounded-xl p-1 flex flex-col-reverse lg:flex-row gap-2 lg:gap-6 lg:justify-between '>
        <div className='w-full lg:w-[48.5%] h-full relative'>
          <div className='w-full bg-white pt-7 px-6 pb-4 rounded-tl-lg mb-3'>
            <p className='text-xl text-gray-6 font-semibold mb-6'>Delivery details</p>

            <div className='w-full flex justify-between mb-8 relative'>
              <Line2 className='absolute bottom-[-85%] left-1.5' />
              <div className='flex gap-2'>
                <div className='w-[14px] h-[14px] rounded-full bg-white border-[1.5px] border-[#F73B58]  mt-1' />
                <div>
                  <p className='text-gray-6 text-sm'>{orderCokitchen?.name}</p>
                  <p className='text-[#6F7376] text-sm'>
                    {moment(order?.calculated_order?.created_at).format('h:mm a')}
                  </p>
                </div>
              </div>
              <p className='text-[#6F7376] text-sm'>
                {moment(order?.calculated_order.created_at).format('ddd, Do MMM YYYY')}
              </p>
            </div>
            <div className='w-full flex justify-between mb-8'>
              <div className='flex gap-2  text-red-5 w-[60%]'>
                <LocationIcon className='mt-1' />
                <div className='w-[90%]'>
                  <p className='text-gray-6 text-sm line-clamp-1'>
                    {order.calculated_order.address_details.address_line}
                  </p>
                  <p className='text-[#6F7376] text-sm'>
                    {moment(order?.calculated_order?.updated_at).format('h:mm a')}
                  </p>
                </div>
              </div>
              <p className='text-[#E60A2B] text-sm capitalize'>{getOrderStatus(order)}</p>
            </div>
          </div>
          <div className='w-full h-[36.5vh] bg-white pt-7 px-6 pb-4 mb-3'>
            <div className='flex justify-between items-center gap-3'>
              <div className='flex gap-2'>
                <CommentIcon />
                <p className='text-sm font-medium'>Cancellation reason</p>
              </div>
              <p className='text-[#6F7376] text-xs'>
                {truncateString(order?.cancelled_note ?? '--', 4)}
              </p>
            </div>
          </div>
        </div>
        <div className='w-full lg:w-[48.5%] h-full bg-white'>
          <div className='w-full bg-white pt-7 px-6 pb-4 rounded-tr-lg mb-3'>
            <p className='text-xl text-gray-6 font-semibold mb-6'>Order details</p>

            <div className='w-full flex flex-col space-y-4'>
              {order.calculated_order.is_company_group_order &&
              order.calculated_order.is_group_order
                ? order.calculated_order.sub_calculated_order_ids?.map((meal, index) => (
                    <GroupOrderMealAccordion meal={meal} key={index} />
                  ))
                : order.calculated_order?.meals.map((meal, index) => (
                    <BulkOrderMealAccordion meal={meal} key={index} />
                  ))}
            </div>
          </div>
        </div>
      </div>
      <ComplaintModal show={showComplaintModal} onClose={() => setShowComplaintModal(false)} />
    </div>
  );
};

export default CancelledOrder;
